import {
  BreederProfilePhotosScreen,
  BreederProfilePhotosScreenProps,
} from 'shared/screens/breeders/profile/breeder-profile-photos';
import { withServerProps } from '@web/library/with-server-props';
import { Page } from '@web/components/page';
import { useTranslation } from 'react-i18next';
import { getBreederProfileSeoTitle } from '@web/library/breeder-profile-seo';
import { BreederProfilePage } from '@web/components/breeder-profile-page';

export default function BreederPhotos(props: BreederProfilePhotosScreenProps) {
  const { t } = useTranslation('screens');
  const title = getBreederProfileSeoTitle(props.breeder, t);

  return (
    <Page
      {...props}
      register={(seo) =>
        seo
          .setTitle(title)
          .setDescription(props.breeder.description ?? '')
          .setImage(props.breeder.avatar?.url)
          .setNoIndex()
      }
    >
      <BreederProfilePage breeder={props.breeder} mediaAssets={props.mediaAssets}>
        <BreederProfilePhotosScreen {...props} />
      </BreederProfilePage>
    </Page>
  );
}

export const getServerSideProps = withServerProps(BreederProfilePhotosScreen.pageBuilder);
